export default __webpack_public_path__ + "static/media/map.827dd375.png";